import * as ApiWithToken from "../callApiWithToken";
import { IReactionDto } from "../../models/dto/generalApi/IReactionDto";
import { IPostInputsSave, IPostInputsUpdate } from "../../models/dto/application/IPostInputs";

const publisherService = {
  getPublisherById: async function () {
    return ApiWithToken.getApi(
      process.env.REACT_APP_GENERAL_API + `Publisher/getPublisherByUser`
    );
  },
  postInsertReaction: async function (reactionDto: IReactionDto) {
    return ApiWithToken.postApi(
      process.env.REACT_APP_GENERAL_API + `Publisher/InsertPostReactions`,
      reactionDto
    );
  },
  getSubretailList: async function () {
    return ApiWithToken.getApi(
      process.env.REACT_APP_GENERAL_API + `Publisher/GetSubregionListPost`
    );
  },
  getRoleList: async function (languageID: number) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_GENERAL_API + `Publisher/GetRoleListPost?languageID=${languageID}`,
    );
  },
  postCreatePost: async function (post: IPostInputsSave) {
    return ApiWithToken.postApi(
      process.env.REACT_APP_GENERAL_API + `Publisher/CreatePost`,
      post
    );
  },
  deletePost: async function (postID: number) {
    return ApiWithToken.deleteApi(
      process.env.REACT_APP_GENERAL_API + `Publisher/DeletePost?postID=${postID}`
    );
  },
  getPostToUpdate: async function (postID: number) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_GENERAL_API + `Publisher/GetPostToUpdate?postID=${postID}`
    );
  },
  putPostUpdate: async function (post: IPostInputsUpdate) {
    return ApiWithToken.putApi(
      process.env.REACT_APP_GENERAL_API + `Publisher/UpdatePost`,
      post
    );
  }
};

export default publisherService;
